import logoHSL from "../../assets/logo.png";
import icon1 from "../../assets/footerIcons/image1.png";
import icon2 from "../../assets/footerIcons/image2.png";
import icon3 from "../../assets/footerIcons/image3.png";
import icon4 from "../../assets/footerIcons/image4.png";
import icon5 from "../../assets/footerIcons/image5.png";
import icon6 from "../../assets/footerIcons/image6.png";
import icon7 from "../../assets/footerIcons/image7.png";
import icon8 from "../../assets/footerIcons/image8.png";
import icon9 from "../../assets/footerIcons/image9.png";
import icon10 from "../../assets/footerIcons/image10.png";
import icon11 from "../../assets/footerIcons/image11.png";
import { Grid, Link, Typography } from '@material-ui/core';

export default function Footer() {

  return (
    <div>
      <Grid container style={{ borderTop: "1px solid #dcdcdc", paddingTop: "2em", marginTop: "2%" }}>
        <Grid item xs={3} >
          <img src={logoHSL} alt="Logo" style={{ height: "41px", width: "171px" }} />
        </Grid>
        <Grid item xs={9} >
          <Typography variant="h6" style={{ fontFamily: "Inter", fontSize: "16px", fontWeight: "bold" }} gutterBottom>
            SAM – Serviço de Apoio ao Médico
          </Typography>
          <Typography variant="subtitle1" style={{ fontFamily: "Inter", fontSize: "16px" }} component="p">
            São Paulo
          </Typography>
          <Typography variant="subtitle1" style={{ fontFamily: "Inter", fontSize: "16px", color: "#8F9194" }} component="p">
            +55 (11) 3394-1000
          </Typography>
          <Typography style={{ fontFamily: "Inter", fontSize: "16px", color: "#45A7DF" }} color="primary" component="p">
            sam@hsl.org.br
          </Typography>
          <Typography variant="subtitle1" style={{ fontFamily: "Inter", fontSize: "16px" }} component="p">
            Brasília
          </Typography>
          <Typography variant="subtitle1" style={{ fontFamily: "Inter", fontSize: "16px", color: "#8F9194" }} component="p" >
            +55 (61) 3044-8888 (opção 6)
          </Typography>
          <Typography style={{ fontFamily: "Inter", fontSize: "16px", color: "#45A7DF" }} color="primary" component="p">
            sambrasilia@hsl.org.br
          </Typography>
        </Grid>
      </Grid>

      <Grid container style={{ paddingTop: "2em" }}>
        <Grid item sm={11}>
          <Typography style={{ fontFamily: "Inter", fontSize: "14px", color: "#C6C8CC" }} variant="h6" >
            Prêmios e Reconhecimentos
          </Typography>
        </Grid>
      </Grid>

      <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item xs={1}>
          <img src={icon1} alt="Ícones" style={{ width: "3.75rem", height: "auto", objectFit: "contain", maxHeight: "80px" }} />
        </Grid>
        <Grid item xs={1}>
          <img src={icon2} alt="Ícones" style={{ width: "3.75rem", height: "auto", objectFit: "contain", maxHeight: "80px" }} />
        </Grid>
        <Grid item xs={1}>
          <img src={icon3} alt="Ícones" style={{ width: "3.75rem", height: "auto", objectFit: "contain", maxHeight: "80px" }} />
        </Grid>
        <Grid item xs={1}>
          <img src={icon4} alt="Ícones" style={{ width: "3.75rem", height: "auto", objectFit: "contain", maxHeight: "80px" }} />
        </Grid>
        <Grid item xs={1}>
          <img src={icon5} alt="Ícones" style={{ width: "3.75rem", height: "auto", objectFit: "contain", maxHeight: "80px" }} />
        </Grid>
        <Grid item xs={1}>
          <img src={icon6} alt="Ícones" style={{ width: "3.75rem", height: "auto", objectFit: "contain", maxHeight: "80px" }} />
        </Grid>
        <Grid item xs={1}>
          <img src={icon7} alt="Ícones" style={{ width: "3.75rem", height: "auto", objectFit: "contain", maxHeight: "80px" }} />
        </Grid>
        <Grid item xs={1}>
          <img src={icon8} alt="Ícones" style={{ width: "3.75rem", height: "auto", objectFit: "contain", maxHeight: "80px" }} />
        </Grid>
        <Grid item xs={1}>
          <img src={icon9} alt="Ícones" style={{ width: "3.75rem", height: "auto", objectFit: "contain", maxHeight: "80px" }} />
        </Grid>
        <Grid item xs={1}>
          <img src={icon10} alt="Ícones" style={{ width: "3.75rem", height: "auto", objectFit: "contain", maxHeight: "80px" }} />
        </Grid>
        <Grid item xs={1}>
          <img src={icon11} alt="Ícones" style={{ width: "3.75rem", height: "auto", objectFit: "contain", maxHeight: "80px" }} />
        </Grid>
      </Grid>

      <Copyright />
    </div >
  );
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center" style={{ paddingTop: "1em", paddingBottom: "1em", borderTop: "1px solid #dcdcdc" }}>
      {"© "}
      {new Date().getFullYear()}

      <Link
        color="inherit"
        href="https://www.hospitalsiriolibanes.org.br/"
        target="_blank"
      >
        {" Hospital Sírio-Libanês "}
      </Link>
      - v2.4.0
    </Typography>
  );
}
